/**
 * The roles a user can hold in the Supabase database, one per Cognito group,
 * with no hierarchy between them. Mirrors the CHECK on public.app_user_roles.role.
 */
export enum AppUserRole {
  Student = 'student',
  Teacher = 'teacher',
  Manager = 'manager',
  Admin = 'admin',
  Owner = 'owner',
}
